module.exports = __webpack_public_path__ + "static/media/img-compras-seguras.efb16917.png";